// extracted by mini-css-extract-plugin
module.exports = {"container":"_1R5X7","row":"_2FJXE","column":"FUBLF","iconColumn":"_18wxR"};